/* eslint-disable */
const LangIdleMonitor = {
	"idleMonitor.warnMessage": [
		"You will be logged out automatically in ${time} minutes.",
		"​លោក​អ្នក ​​​នឹង​ចេញ​ពី​គណនី​ដោយ​ស្វ័យ​ប្រវត្តិបន្ទាប់​ពី ${time} នាទី.",
	],
	"idleMonitor.sessionExpired": [
		"Your session was expired.",
		"​លោក​អ្នក​​​​ ត្រូវ​បាន​ចាក​ចេញ​ពី​គណនី​",
	],
}

export default LangIdleMonitor



// WEBPACK FOOTER //
// ./src/resources/modules/LangIdleMonitor.js